import React from "react";

export default function MapView({ trip }) {
  const { lat, lng } = trip.map_center || {};
  if (!lat || !lng) return null;
  const delta = 0.08;
  const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(",");
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
  return (
    <div className="bg-white rounded-[1.5rem] overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid="map-view">
      <iframe
        title="map"
        src={src}
        className="w-full h-72 md:h-96"
        loading="lazy"
      />
      <div className="p-3 flex items-center justify-between text-xs text-gray-500 border-t border-[#F5F5F7]">
        <span>Peta interaktif — {trip.destination}</span>
        <a
          className="text-[#4FB3E8] hover:underline"
          target="_blank"
          rel="noreferrer"
          href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
        >
          Buka di Google Maps
        </a>
      </div>
    </div>
  );
}
